import {
    UPDATE_SELECTED,
    UPDATE_FLIPPED,
    UPDATE_SCORE,
    UPDATE_COMPLETE,
    UPDATE_CARDS,
    UPDATE_CURRENT,
    UPDATE_PROCESSING,
    UPDATE_COLLECTIONS,
    RESTORE_FLIP_STATE,
} from "./constants";
import FlipMatchSuccess from "../../components/FlipMatchSuccess/FlipMatchSuccess";

export const initialState = {
    flip: {
        complete: false,
        completeScreen: {
            component: FlipMatchSuccess,
            props: {}
        },
        collection: {
            name: '',
            title: '',
            description: '',
            theme: '',
            cards: []
        },
        collections: {},
        collectionDefault: 'planets',
        dealTrigger: 0,
        flipped: [],
        selected: [],
        current: false,
        processing: false,
        score: 0
    }
};

export const flip = (state = initialState.flip, { type, payload }) => {
    if (type === UPDATE_SELECTED) {
        const selected = payload.remove
            ? state.selected.filter(item => {
                return payload.selected.some(value => value.name === item.name) ? false : item
            })
            : [...state.selected, ...payload.selected];
        return {...state, selected};
    }
    if (type === UPDATE_FLIPPED) {
        const flipped = payload.remove
            ? state.flipped.filter(item => {
                return payload.flipped.some(value => value.name === item.name) ? false : item
            })
            : [...state.flipped, ...payload.flipped];
        return {...state, flipped};
    }
    if (type === UPDATE_CURRENT) {
        return {...state, ...{current:payload}};
    }
    if (type === UPDATE_COMPLETE) {
        return {...state, ...{complete:payload}};
    }
    if (type === UPDATE_SCORE) {
        return {...state, ...{score: payload}};
    }
    if (type === UPDATE_COLLECTIONS) {
        return {...state, ...{collections: payload}};
    }
    if (type === UPDATE_CARDS) {
        return {...state, collection: payload, dealTrigger: (state.dealTrigger || 0) + 1};
    }
    if (type === UPDATE_PROCESSING) {
        return {...state, ...{processing: payload}};
    }
    if (type === RESTORE_FLIP_STATE) {
        return {
            ...state,
            collection: payload.collection,
            flipped: payload.flipped,
            selected: [],
            current: false,
        };
    }
    return state;
};